export var colorPickerItemDataHook = 'color-picker-item';
export var colorPickerItemTooltipDataHook = 'color-picker-item-tooltip';
export var colorPickerItemDataCrossed = 'data-crossed';
export var colorPickerItemCheckedDateHook = 'data-color-picker-item-checked';
export var colorPickerFieldsetLabelDataHook = 'color-picker-fieldset-label';
//# sourceMappingURL=dataHooks.js.map